// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"70e8ed19","208":"4dc58cb9","272":"835b061e","301":"61ec14aa","424":"f5cbba65","451":"3ed6a22c","477":"cd1cb319","483":"04920f9c","512":"d0faca96","567":"7cbf267f","848":"994b4b35","931":"6ebe62b1"}[chunkId] + ".chunk.js";
};